import React from 'react'

const NdrInsightsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 50 50"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g transform="matrix(-1,-3.6739403974420604e-16,-3.6739403974420604e-16,1,49.999999999999986,7.105427357601002e-15)">
                    <path
                        fill="#282828"
                        d="m18.928 46.188 2.544 1.426.733.072 1.014-.75-1.666-2.264-1.094-.407zM39.239 34.636l2.245 1.304 1.126-.03.92-.524-1.667-2.265-1.094-.407z"
                        opacity={1}
                        data-original="#282828"
                    />
                    <path
                        fill="#2b2f35"
                        d="m48.86 26.418-15.051-8.746a.228.228 0 0 0-.038-.018l15.051 8.747c.014.005.026.01.038.017"
                        opacity={1}
                        data-original="#2b2f35"
                    />
                    <path
                        fill="#2d3137"
                        d="m48.822 26.401-15.05-8.747a.227.227 0 0 0-.033-.009l15.051 8.747a.227.227 0 0 1 .032.01"
                        opacity={1}
                        data-original="#2d3137"
                    />
                    <path
                        fill="#2e3339"
                        d="M48.79 26.392 33.74 17.645a.286.286 0 0 0-.027-.004l15.051 8.747.027.004"
                        opacity={1}
                        data-original="#2e3339"
                    />
                    <path
                        fill="#30353b"
                        d="m48.763 26.388-15.05-8.747a.272.272 0 0 0-.025 0l15.051 8.746.024.001"
                        opacity={1}
                        data-original="#30353b"
                    />
                    <path
                        fill="#33383d"
                        d="M48.74 26.387 33.687 17.64l-.022.001 15.052 8.747a.4.4 0 0 1 .021 0"
                        opacity={1}
                        data-original="#33383d"
                    />
                    <path
                        fill="#33393f"
                        d="M48.718 26.388 33.666 17.64a.378.378 0 0 0-.02.002l15.051 8.747a.248.248 0 0 1 .02-.002"
                        opacity={1}
                        data-original="#33393f"
                    />
                    <path
                        fill="#353a41"
                        d="m48.697 26.39-15.051-8.747a.369.369 0 0 0-.02.003l15.05 8.747a.385.385 0 0 1 .021-.003"
                        opacity={1}
                        data-original="#353a41"
                    />
                    <path
                        fill="#373c43"
                        d="m48.677 26.393-15.051-8.747a.32.32 0 0 0-.02.005l15.052 8.747a.32.32 0 0 1 .019-.005"
                        opacity={1}
                        data-original="#373c43"
                    />
                    <path
                        fill="#393e45"
                        d="M48.658 26.398 33.607 17.65a.365.365 0 0 0-.02.005l15.052 8.747a.365.365 0 0 1 .019-.005"
                        opacity={1}
                        data-original="#393e45"
                    />
                    <path
                        fill="#3a4047"
                        d="m48.639 26.403-15.051-8.747a.495.495 0 0 0-.019.006l15.051 8.747a.36.36 0 0 1 .019-.006"
                        opacity={1}
                        data-original="#3a4047"
                    />
                    <path
                        fill="#3c4249"
                        d="m48.62 26.409-15.05-8.747a.469.469 0 0 0-.02.007l15.052 8.747a.536.536 0 0 1 .018-.007"
                        opacity={1}
                        data-original="#3c4249"
                    />
                    <path
                        fill="#3e434b"
                        d="M48.602 26.416 33.55 17.669a.482.482 0 0 0-.019.008l15.051 8.747a.917.917 0 0 1 .019-.008"
                        opacity={1}
                        data-original="#3e434b"
                    />
                    <path
                        fill="#40454e"
                        d="m48.583 26.424-15.051-8.747a.622.622 0 0 0-.019.009l15.052 8.746a.768.768 0 0 1 .018-.008"
                        opacity={1}
                        data-original="#40454e"
                    />
                    <path
                        fill="#424750"
                        d="m48.565 26.432-15.052-8.746a.489.489 0 0 0-.019.01l15.052 8.746a.867.867 0 0 1 .019-.01"
                        opacity={1}
                        data-original="#424750"
                    />
                    <path
                        fill="#424952"
                        d="m48.546 26.442-15.051-8.747-.015.008L48.53 26.45z"
                        opacity={1}
                        data-original="#424952"
                    />
                    <path
                        fill="#484e58"
                        d="M48.531 26.45 33.48 17.703l-.113.066 15.052 8.746zM48.419 26.515 33.367 17.77l-22.504 12.82 15.05 8.748z"
                        opacity={1}
                        data-original="#484e58"
                    />
                    <path
                        fill="#686868"
                        d="M1 36.816v1.745c.01.149.056.251.14.307l15.05 8.746c-.083-.055-.13-.158-.13-.306l-.01-1.746c0-.287.205-.65.465-.798l9.397-5.432-15.051-8.746-9.397 5.431c-.26.149-.464.502-.464.799z"
                        opacity={1}
                        data-original="#686868"
                    />
                    <path
                        fill="#4f4d4d"
                        d="M16.512 44.765a1.017 1.017 0 0 0-.461.798l.005 1.744c0 .3.209.419.464.271l32.02-18.314a1.02 1.02 0 0 0 .46-.805l-.005-1.744c0-.293-.209-.412-.464-.265l-.112.065-22.505 12.822z"
                        opacity={1}
                        data-original="#4f4d4d"
                        className=""
                    />
                    <path
                        fill="#929393"
                        d="m43.206 31.657.047-.047v1.7c-.01 0-.028 0-.037-.01h-.065c-.01-.01-.02-.01-.038-.01l-.009-.008c-.01 0-.019 0-.028-.01h-.009c-.019-.009-.028-.018-.037-.018l-.01-.01c-.009 0-.018-.01-.027-.018 0 0-.01 0-.01-.01-.009 0-.018-.009-.028-.018-.018-.01-.027-.028-.037-.037v-.01l-.027-.027v-.01a.126.126 0 0 1-.028-.037v-.01c-.01-.009-.01-.018-.019-.036v-.01a.07.07 0 0 1-.018-.046l-.01-.01c0-.009 0-.027-.009-.037v-.018c-.01-.01-.01-.028-.01-.046v-.01c0-.018-.009-.037-.009-.055v-.15c0-.018 0-.036.01-.055v-.009c0-.028 0-.047.009-.065v-.019c0-.018.01-.037.01-.055 0 0 0-.01.009-.019 0-.018.009-.037.009-.055 0-.01.01-.02.01-.02 0-.018.008-.036.008-.055.01 0 .01-.009.01-.018.009-.02.018-.038.018-.056.01-.01.01-.01.01-.019.009-.018.009-.037.018-.046.01-.01.01-.019.01-.028l.027-.056v-.01a.192.192 0 0 1 .037-.055c0-.01 0-.018.01-.018l.028-.056v-.01a.195.195 0 0 0 .037-.055c.009-.01.009-.019.009-.019.01-.018.028-.037.037-.046 0-.01 0-.01.01-.019a.189.189 0 0 1 .037-.055l.009-.01c.01-.018.028-.028.037-.046 0-.01.01-.01.01-.018z"
                        opacity={1}
                        data-original="#929393"
                        className=""
                    />
                    <path
                        fill="#b94234"
                        d="M24.954 27.446 9.903 18.699l.014 5.238 15.052 8.747z"
                        opacity={1}
                        data-original="#b94234"
                    />
                    <path
                        fill="#7e2c23"
                        d="M24.913 27.359 9.862 18.612c.01.005.018.014.024.024l15.052 8.746a.073.073 0 0 0-.025-.023"
                        opacity={1}
                        data-original="#7e2c23"
                    />
                    <path
                        fill="#812e24"
                        d="M24.938 27.382 9.886 18.636l.006.01 15.05 8.746z"
                        opacity={1}
                        data-original="#812e24"
                    />
                    <path
                        fill="#853026"
                        d="M24.943 27.392 9.892 18.645l.003.008L24.946 27.4z"
                        opacity={1}
                        data-original="#853026"
                    />
                    <path
                        fill="#8b3227"
                        d="M24.946 27.4 9.895 18.653l.002.007 15.052 8.747z"
                        opacity={1}
                        data-original="#8b3227"
                    />
                    <path
                        fill="#903329"
                        d="M24.949 27.407 9.897 18.66l.002.007 15.051 8.747z"
                        opacity={1}
                        data-original="#903329"
                    />
                    <path
                        fill="#95352b"
                        d="M24.95 27.414 9.9 18.667v.007l15.052 8.747z"
                        opacity={1}
                        data-original="#95352b"
                        className=""
                    />
                    <path
                        fill="#9a362b"
                        d="M24.952 27.42 9.9 18.675l.001.006 15.052 8.747z"
                        opacity={1}
                        data-original="#9a362b"
                    />
                    <path
                        fill="#9e382c"
                        d="M24.953 27.427 9.9 18.68l.001.006 15.051 8.747z"
                        opacity={1}
                        data-original="#9e382c"
                    />
                    <path
                        fill="#a33a2e"
                        d="M24.953 27.433 9.902 18.686v.006l15.052 8.747z"
                        opacity={1}
                        data-original="#a33a2e"
                    />
                    <path
                        fill="#a83b2f"
                        d="M24.954 27.44 9.902 18.691v.006l15.052 8.747z"
                        opacity={1}
                        data-original="#a83b2f"
                    />
                    <path
                        fill="#ac3c30"
                        d="M24.954 27.445 9.903 18.698l15.05 8.748"
                        opacity={1}
                        data-original="#ac3c30"
                    />
                    <path
                        fill="#24282d"
                        d="M24.913 27.359 9.862 18.612l-.011-.005 15.05 8.746z"
                        opacity={1}
                        data-original="#24282d"
                    />
                    <path
                        fill="#26292e"
                        d="M24.902 27.353 9.85 18.607l-.01-.003 15.051 8.747z"
                        opacity={1}
                        data-original="#26292e"
                    />
                    <path
                        fill="#272b30"
                        d="M24.892 27.35 9.841 18.605l-.008-.001 15.051 8.747z"
                        opacity={1}
                        data-original="#272b30"
                    />
                    <path
                        fill="#292c32"
                        d="m24.884 27.35-15.05-8.747h-.008l15.051 8.746z"
                        opacity={1}
                        data-original="#292c32"
                    />
                    <path
                        fill="#2a2e34"
                        d="m24.877 27.35-15.05-8.748H9.82l15.05 8.747z"
                        opacity={1}
                        data-original="#2a2e34"
                    />
                    <path
                        fill="#2b2f35"
                        d="M24.87 27.35 9.82 18.602h-.006l15.051 8.747z"
                        opacity={1}
                        data-original="#2b2f35"
                    />
                    <path
                        fill="#2d3137"
                        d="M24.865 27.35 9.814 18.603l-.006.001 15.051 8.747z"
                        opacity={1}
                        data-original="#2d3137"
                    />
                    <path
                        fill="#2e3239"
                        d="M24.86 27.351 9.807 18.604l-.006.001 15.052 8.747z"
                        opacity={1}
                        data-original="#2e3239"
                    />
                    <path
                        fill="#30343a"
                        d="M24.854 27.352 9.802 18.605l-.005.002 15.051 8.747z"
                        opacity={1}
                        data-original="#30343a"
                    />
                    <path
                        fill="#31353c"
                        d="M24.848 27.354 9.797 18.607l-.006.002 15.052 8.747z"
                        opacity={1}
                        data-original="#31353c"
                    />
                    <path
                        fill="#32373e"
                        d="M24.843 27.356 9.792 18.609l-.006.002 15.051 8.747z"
                        opacity={1}
                        data-original="#32373e"
                    />
                    <path
                        fill="#343940"
                        d="M24.837 27.358 9.787 18.61l-.006.002 15.051 8.747z"
                        opacity={1}
                        data-original="#343940"
                    />
                    <path
                        fill="#353a41"
                        d="M24.832 27.36 9.781 18.613l-.005.003 15.05 8.746z"
                        opacity={1}
                        data-original="#353a41"
                    />
                    <path
                        fill="#383c44"
                        d="M24.827 27.362 9.775 18.616l-.005.002 15.051 8.747z"
                        opacity={1}
                        data-original="#383c44"
                    />
                    <path
                        fill="#383d46"
                        d="M24.821 27.365 9.77 18.618l-.004.003 15.051 8.747z"
                        opacity={1}
                        data-original="#383d46"
                    />
                    <path
                        fill="#d7d7d7"
                        d="m10.823 15.804.038 14.782 15.05 8.746-.037-14.782c0-.463.258-1.004.617-1.369L11.44 14.435c-.36.363-.616.905-.616 1.369z"
                        opacity={1}
                        data-original="#d7d7d7"
                    />
                    <path
                        fill="#e8e8e8"
                        d="M33.048 2.381c-.176-.102-.408-.093-.677.066L11.76 14.17c-.114.067-.22.162-.321.265l15.05 8.746c.101-.102.208-.197.322-.264l20.61-11.724c.269-.158.51-.167.677-.065z"
                        opacity={1}
                        data-original="#e8e8e8"
                        className=""
                    />
                    <path
                        fill="#bfbfbf"
                        d="M26.811 22.92c-.521.302-.94 1.035-.94 1.635l.043 14.781 22.504-12.82-.041-14.782c-.002-.6-.424-.847-.952-.542z"
                        opacity={1}
                        data-original="#bfbfbf"
                        className=""
                    />
                    <path
                        fill="#ce493a"
                        d="M24.833 32.913 9.782 24.166l-6.415 3.703 15.051 8.747z"
                        opacity={1}
                        data-original="#ce493a"
                    />
                    <path
                        fill="#c04335"
                        d="M18.419 36.616 3.367 27.869l-.013.007 15.052 8.747z"
                        opacity={1}
                        data-original="#c04335"
                    />
                    <path
                        fill="#bb4234"
                        d="M18.406 36.623 3.354 27.876a.529.529 0 0 1-.016.009l15.05 8.747a.441.441 0 0 0 .018-.009"
                        opacity={1}
                        data-original="#bb4234"
                    />
                    <path
                        fill="#b64033"
                        d="M18.389 36.632 3.338 27.885a.474.474 0 0 1-.017.008l15.052 8.746a.478.478 0 0 0 .016-.007"
                        opacity={1}
                        data-original="#b64033"
                    />
                    <path
                        fill="#b13e32"
                        d="M18.373 36.64 3.32 27.892a.429.429 0 0 1-.016.006l15.051 8.747a.429.429 0 0 0 .017-.007"
                        opacity={1}
                        data-original="#b13e32"
                    />
                    <path
                        fill="#ac3c30"
                        d="M18.357 36.646 3.305 27.9a.629.629 0 0 1-.015.006l15.05 8.747a.629.629 0 0 0 .017-.006"
                        opacity={1}
                        data-original="#ac3c30"
                    />
                    <path
                        fill="#a83b2f"
                        d="M18.34 36.652 3.29 27.905a.37.37 0 0 1-.017.005l15.052 8.747a.268.268 0 0 0 .016-.005"
                        opacity={1}
                        data-original="#a83b2f"
                    />
                    <path
                        fill="#a33a2e"
                        d="M18.325 36.657 3.274 27.911a.353.353 0 0 1-.017.004l15.052 8.747a.353.353 0 0 0 .016-.005"
                        opacity={1}
                        data-original="#a33a2e"
                    />
                    <path
                        fill="#9e382c"
                        d="M18.309 36.662 3.257 27.915a.322.322 0 0 1-.016.004l15.052 8.746a.24.24 0 0 0 .016-.003"
                        opacity={1}
                        data-original="#9e382c"
                    />
                    <path
                        fill="#9a362b"
                        d="M18.293 36.665 3.242 27.92a.27.27 0 0 1-.018.002l15.051 8.747a.214.214 0 0 0 .018-.003"
                        opacity={1}
                        data-original="#9a362b"
                    />
                    <path
                        fill="#95352b"
                        d="m18.275 36.668-15.05-8.747a.248.248 0 0 1-.018.002L18.26 36.67a.322.322 0 0 0 .016-.002"
                        opacity={1}
                        data-original="#95352b"
                        className=""
                    />
                    <path
                        fill="#903329"
                        d="M18.259 36.67 3.207 27.923H3.19l15.05 8.747h.02"
                        opacity={1}
                        data-original="#903329"
                    />
                    <path
                        fill="#8b3227"
                        d="M18.24 36.67 3.189 27.924l-.02-.001 15.052 8.747h.019"
                        opacity={1}
                        data-original="#8b3227"
                    />
                    <path
                        fill="#853026"
                        d="M18.22 36.67 3.17 27.923a.196.196 0 0 1-.024-.004l15.052 8.747a.193.193 0 0 0 .023.004"
                        opacity={1}
                        data-original="#853026"
                    />
                    <path
                        fill="#812e24"
                        d="M18.198 36.666 3.146 27.92a.194.194 0 0 1-.027-.007l15.051 8.747a.194.194 0 0 0 .028.007"
                        opacity={1}
                        data-original="#812e24"
                    />
                    <path
                        fill="#7e2c23"
                        d="M18.17 36.658 3.119 27.912a.196.196 0 0 1-.031-.015l15.051 8.747a.2.2 0 0 0 .031.014"
                        opacity={1}
                        data-original="#7e2c23"
                    />
                    <path
                        fill="#424751"
                        d="M18.067 36.15 3.016 27.404l-.005.013 15.051 8.747z"
                        opacity={1}
                        data-original="#424751"
                    />
                    <path
                        fill="#404650"
                        d="M18.062 36.164 3.011 27.417a.71.71 0 0 0-.007.022l15.051 8.747.007-.022"
                        opacity={1}
                        data-original="#404650"
                    />
                    <path
                        fill="#40444d"
                        d="M18.055 36.186 3.004 27.44a.904.904 0 0 0-.007.022l15.052 8.747.006-.022"
                        opacity={1}
                        data-original="#40444d"
                    />
                    <path
                        fill="#3e434c"
                        d="M18.049 36.208 2.997 27.461l-.005.022 15.05 8.747.007-.022"
                        opacity={1}
                        data-original="#3e434c"
                    />
                    <path
                        fill="#3d414a"
                        d="M18.043 36.23 2.992 27.483a.608.608 0 0 0-.005.022l15.05 8.747a.663.663 0 0 1 .006-.022"
                        opacity={1}
                        data-original="#3d414a"
                    />
                    <path
                        fill="#3b4048"
                        d="M18.038 36.252 2.987 27.505l-.005.02 15.052 8.748c0-.007.002-.014.004-.022"
                        opacity={1}
                        data-original="#3b4048"
                    />
                    <path
                        fill="#393e47"
                        d="M18.034 36.273 2.982 27.526a.545.545 0 0 0-.003.02l15.051 8.747a.545.545 0 0 1 .004-.02"
                        opacity={1}
                        data-original="#393e47"
                    />
                    <path
                        fill="#383d46"
                        d="M18.03 36.293 2.98 27.546l-.003.02 15.051 8.747.003-.02"
                        opacity={1}
                        data-original="#383d46"
                    />
                    <path
                        fill="#383c44"
                        d="M18.027 36.313 2.976 27.566l-.002.02 15.051 8.747.002-.02"
                        opacity={1}
                        data-original="#383c44"
                    />
                    <path
                        fill="#353a41"
                        d="M18.025 36.333 2.974 27.586a.639.639 0 0 0-.002.019l15.051 8.747.002-.02"
                        opacity={1}
                        data-original="#353a41"
                    />
                    <path
                        fill="#343940"
                        d="m18.023 36.352-15.05-8.747-.002.019 15.052 8.746v-.018"
                        opacity={1}
                        data-original="#343940"
                    />
                    <path
                        fill="#32373e"
                        d="M18.023 36.37 2.97 27.624v.019l15.051 8.746v-.019"
                        opacity={1}
                        data-original="#32373e"
                    />
                    <path
                        fill="#31353c"
                        d="m18.022 36.39-15.05-8.748v.019l15.05 8.747v-.019"
                        opacity={1}
                        data-original="#31353c"
                    />
                    <path
                        fill="#30343a"
                        d="M18.023 36.408 2.972 27.66v.019l15.052 8.747a.57.57 0 0 1-.001-.02"
                        opacity={1}
                        data-original="#30343a"
                    />
                    <path
                        fill="#2e3239"
                        d="M18.024 36.427 2.973 27.68l.002.018 15.05 8.747a.531.531 0 0 1-.001-.018"
                        opacity={1}
                        data-original="#2e3239"
                    />
                    <path
                        fill="#2d3137"
                        d="M18.026 36.445 2.975 27.7l.003.019 15.05 8.747a.526.526 0 0 1-.002-.02"
                        opacity={1}
                        data-original="#2d3137"
                    />
                    <path
                        fill="#2b2f35"
                        d="M18.029 36.465 2.978 27.718a.517.517 0 0 0 .004.02l15.05 8.746a.355.355 0 0 1-.003-.02"
                        opacity={1}
                        data-original="#2b2f35"
                    />
                    <path
                        fill="#2a2e34"
                        d="M18.033 36.484 2.982 27.737a.307.307 0 0 0 .005.02l15.051 8.748a.304.304 0 0 1-.005-.02"
                        opacity={1}
                        data-original="#2a2e34"
                    />
                    <path
                        fill="#292c32"
                        d="M18.038 36.505 2.987 27.758a.326.326 0 0 0 .007.021l15.051 8.747a.401.401 0 0 1-.007-.021"
                        opacity={1}
                        data-original="#292c32"
                    />
                    <path
                        fill="#272b30"
                        d="M18.045 36.526 2.994 27.779a.293.293 0 0 0 .01.024l15.051 8.747a.329.329 0 0 1-.01-.024"
                        opacity={1}
                        data-original="#272b30"
                    />
                    <path
                        fill="#26292e"
                        d="m18.055 36.55-15.05-8.747c.004.01.01.02.015.028l15.05 8.747a.254.254 0 0 1-.015-.028"
                        opacity={1}
                        data-original="#26292e"
                    />
                    <path
                        fill="#24282d"
                        d="M18.07 36.578 3.02 27.83c.018.028.04.05.068.066l15.051 8.747a.202.202 0 0 1-.068-.066"
                        opacity={1}
                        data-original="#24282d"
                    />
                    <path
                        fill="#ef5a5a"
                        d="m1.603 28.877.02 7.048 15.05 8.746-.018-7.047c0-.149.027-.298.083-.464l-15.05-8.747a1.444 1.444 0 0 0-.084.464z"
                        opacity={1}
                        data-original="#ef5a5a"
                    />
                    <path
                        fill="#3d414a"
                        d="M24.817 27.368 9.766 18.62l-4.298 2.481 15.051 8.747z"
                        opacity={1}
                        data-original="#3d414a"
                    />
                    <path
                        fill="#424851"
                        d="M20.164 30.3 5.113 21.553l-2.097 5.85 15.05 8.747z"
                        opacity={1}
                        data-original="#424851"
                    />
                    <path
                        fill="#383d46"
                        d="M20.52 29.849 5.467 21.102l-.004.002 15.051 8.747z"
                        opacity={1}
                        data-original="#383d46"
                    />
                    <path
                        fill="#393e47"
                        d="m20.515 29.851-15.05-8.747a.552.552 0 0 0-.017.01l15.05 8.747a.552.552 0 0 1 .017-.01"
                        opacity={1}
                        data-original="#393e47"
                    />
                    <path
                        fill="#3b4048"
                        d="M20.499 29.861 5.448 21.114a.81.81 0 0 0-.017.011l15.051 8.747a.614.614 0 0 1 .017-.01"
                        opacity={1}
                        data-original="#3b4048"
                    />
                    <path
                        fill="#3d414a"
                        d="M20.482 29.872 5.431 21.125a.606.606 0 0 0-.017.013l15.05 8.746.018-.012"
                        opacity={1}
                        data-original="#3d414a"
                    />
                    <path
                        fill="#3e434c"
                        d="M20.465 29.884 5.414 21.139l-.018.013 15.051 8.747a1.15 1.15 0 0 1 .018-.013"
                        opacity={1}
                        data-original="#3e434c"
                    />
                    <path
                        fill="#40444d"
                        d="M20.447 29.898 5.397 21.15a.805.805 0 0 0-.019.015l15.052 8.746a.594.594 0 0 1 .017-.014"
                        opacity={1}
                        data-original="#40444d"
                    />
                    <path
                        fill="#404650"
                        d="M20.43 29.912 5.378 21.166a.841.841 0 0 0-.018.015l15.052 8.747a.841.841 0 0 1 .018-.016"
                        opacity={1}
                        data-original="#404650"
                    />
                    <path
                        fill="#424751"
                        d="M20.412 29.928 5.36 21.181a.69.69 0 0 0-.017.017l15.05 8.747a.677.677 0 0 1 .019-.017"
                        opacity={1}
                        data-original="#424751"
                    />
                    <path
                        fill="#434953"
                        d="M20.394 29.945 5.343 21.198a.687.687 0 0 0-.018.017l15.052 8.747.017-.017"
                        opacity={1}
                        data-original="#434953"
                    />
                    <path
                        fill="#454a55"
                        d="M20.377 29.962 5.326 21.215l-.017.017 15.051 8.747.017-.017"
                        opacity={1}
                        data-original="#454a55"
                    />
                    <path
                        fill="#464c56"
                        d="M20.36 29.979 5.31 21.232a.668.668 0 0 0-.016.018l15.051 8.747a.932.932 0 0 1 .016-.018"
                        opacity={1}
                        data-original="#464c56"
                    />
                    <path
                        fill="#5c626b"
                        d="M20.344 29.997 5.294 21.25l-.016.018 15.05 8.747a.926.926 0 0 1 .016-.018"
                        opacity={1}
                        data-original="#5c626b"
                    />
                    <path
                        fill="#656a73"
                        d="M20.329 30.015 5.278 21.268a.73.73 0 0 0-.016.02l15.051 8.746.016-.02"
                        opacity={1}
                        data-original="#656a73"
                    />
                    <path
                        fill="#6d7279"
                        d="M20.313 30.034 5.262 21.287a.776.776 0 0 0-.017.022l15.051 8.747.017-.022"
                        opacity={1}
                        data-original="#6d7279"
                    />
                    <path
                        fill="#72777f"
                        d="M20.296 30.056 5.245 21.31a.9.9 0 0 0-.025.035l15.051 8.747a.982.982 0 0 1 .025-.035"
                        opacity={1}
                        data-original="#72777f"
                    />
                    <path
                        fill="#787c83"
                        d="m20.271 30.091-15.05-8.747a.998.998 0 0 0-.034.054l15.05 8.746.035-.053"
                        opacity={1}
                        data-original="#787c83"
                    />
                    <path
                        fill="#72777f"
                        d="M20.238 30.144 5.187 21.398a1.139 1.139 0 0 0-.02.036l15.05 8.746.02-.036"
                        opacity={1}
                        data-original="#72777f"
                    />
                    <path
                        fill="#6d7279"
                        d="M20.218 30.18 5.167 21.433a.784.784 0 0 0-.013.025l15.051 8.746.013-.024"
                        opacity={1}
                        data-original="#6d7279"
                    />
                    <path
                        fill="#656a73"
                        d="m20.205 30.204-15.05-8.746a.825.825 0 0 0-.011.02l15.051 8.748.01-.022"
                        opacity={1}
                        data-original="#656a73"
                    />
                    <path
                        fill="#5c626b"
                        d="M20.195 30.226 5.144 21.479a1.215 1.215 0 0 0-.01.02l15.052 8.747.01-.02"
                        opacity={1}
                        data-original="#5c626b"
                    />
                    <path
                        fill="#464c56"
                        d="M20.186 30.246 5.135 21.499a.68.68 0 0 0-.009.02l15.052 8.746.008-.02"
                        opacity={1}
                        data-original="#464c56"
                    />
                    <path
                        fill="#454a55"
                        d="M20.178 30.265 5.126 21.518l-.008.02 15.052 8.747a.69.69 0 0 1 .008-.02"
                        opacity={1}
                        data-original="#454a55"
                    />
                    <path
                        fill="#434953"
                        d="M20.17 30.285 5.118 21.538l-.005.015L20.164 30.3z"
                        opacity={1}
                        data-original="#434953"
                    />
                    <path
                        fill="#dd454d"
                        d="M19.332 30.043c.13-.355.384-.679.657-.836l5.887-3.399.038 13.528-9.242 5.336-.02-7.05c0-.143.029-.296.088-.46zm-.914 6.573 6.415-3.703a.291.291 0 0 0 .136-.23l-.015-5.238c0-.081-.06-.122-.137-.078l-4.298 2.482a.891.891 0 0 0-.355.45l-2.097 5.851c-.136.385.055.637.351.466"
                        opacity={1}
                        data-original="#dd454d"
                    />
                    <path
                        fill="#39414d"
                        d="M20.164 30.3a.892.892 0 0 1 .355-.451l4.045-2.335.014 4.984a.292.292 0 0 1-.136.229l-6.413 3.702a.641.641 0 0 1 .038-.279z"
                        opacity={1}
                        data-original="#39414d"
                    />
                    <path
                        fill="#ef5a5a"
                        d="m4.278 21.3 15.05 8.747c.13-.362.39-.687.66-.845l5.887-3.398-15.051-8.746-5.887 3.398c-.27.157-.53.482-.66.845z"
                        opacity={1}
                        data-original="#ef5a5a"
                    />
                    <path
                        fill="#bc2b3b"
                        d="M19.332 30.043 4.281 21.296l-2.593 7.12 15.052 8.746z"
                        opacity={1}
                        data-original="#bc2b3b"
                    />
                    <path
                        fill="#39414d"
                        d="m5.357 22.995 12.837 7.46-1.72 4.72-12.837-7.46z"
                        opacity={1}
                        data-original="#39414d"
                    />
                    <path
                        fill="#ef5a5a"
                        d="m3.637 27.716 12.838 7.46-.228.626-13.42-7.8z"
                        opacity={1}
                        data-original="#ef5a5a"
                    />
                    <path
                        fill="#dd454d"
                        d="m4.774 22.656.583.34-1.72 4.72-.81.287z"
                        opacity={1}
                        data-original="#dd454d"
                    />
                    <path
                        fill="#686868"
                        d="M25.238 42.686c.004 1.233-.865 2.73-1.932 3.347-1.073.62-1.941.124-1.945-1.108-.003-1.227.86-2.728 1.932-3.347 1.067-.616 1.942-.118 1.945 1.108zm-1.936 2.06c.12-.07.235-.167.338-.28.282-.312.479-.754.478-1.133-.001-.38-.2-.593-.483-.578a.76.76 0 0 0-.338.11c-.45.26-.817.895-.815 1.413 0 .517.37.727.82.467"
                        opacity={1}
                        data-original="#686868"
                    />
                    <path
                        fill="#888888"
                        d="M24.12 43.27v.129s0 .01-.01.019v.065c0 .018-.009.037-.009.064v.01c-.01.028-.01.046-.019.065v.009c-.009.019-.009.047-.018.065v.01c-.01.027-.01.046-.019.064 0 0 0 .01-.009.01 0 .018-.01.046-.019.065 0 .009 0 .009-.009.009 0 .028-.01.046-.018.065 0 0 0 .01-.01.01a.62.62 0 0 0-.028.074c-.009.018-.027.037-.037.064v.01c-.028.037-.055.083-.083.13v.01c-.028.036-.056.083-.084.12l-.01.01c-.027.036-.064.073-.092.11 0 .01 0 .01-.01.01v.009l-.027.028c-.01 0-.01.01-.019.01 0 .008-.009.018-.018.027-.01 0-.01.01-.019.01l-.065.064c-.01 0-.01.01-.018.01-.01.009-.019.018-.028.018 0 .01-.01.01-.01.019-.009 0-.018.009-.027.018-.01 0-.01.01-.019.01-.01.01-.018.01-.028.018l-.01.01c-.018.009-.027.018-.045.027-.455.26-.818.047-.818-.464-.009-.52.363-1.151.808-1.411a.204.204 0 0 0 .047-.028c.009 0 .009-.01.018-.01s.019-.008.028-.008c0-.01.01-.01.01-.01.009 0 .018-.009.027-.009s.01-.01.019-.01.018-.009.028-.009h.009c.01-.01.019-.01.037-.01.019-.008.028-.008.037-.008.028-.01.056-.01.084-.01.065-.009.13 0 .195.028.028.01.055.028.083.047.01.01.019.018.037.028a.13.13 0 0 1 .028.036c.01.01.019.02.028.038h.01c.009.019.009.028.018.046h.01c0 .019.009.028.018.038v.009c.01.018.01.037.018.055s.01.028.01.047c0 .01.009.01.009.01 0 .018 0 .036.01.055v.065z"
                        opacity={1}
                        data-original="#888888"
                    />
                    <path
                        fill="#3d3d3d"
                        d="M26.311 42.067c.005 1.914-1.336 4.244-3.002 5.205-1.665.962-3.021.19-3.027-1.725-.005-1.907 1.342-4.24 3.008-5.202 1.666-.962 3.016-.186 3.021 1.722zm-3.005 3.966c1.067-.616 1.936-2.114 1.932-3.347-.003-1.226-.878-1.725-1.945-1.109-1.073.62-1.935 2.121-1.932 3.347.003 1.233.872 1.728 1.945 1.109M46.616 30.515c.006 1.914-1.341 4.248-3.001 5.206-1.666.962-3.022.19-3.028-1.725-.005-1.907 1.342-4.24 3.008-5.203 1.66-.958 3.016-.185 3.021 1.722zm-3.005 3.966c1.067-.616 1.93-2.11 1.926-3.343-.003-1.226-.871-1.728-1.938-1.112-1.073.62-1.936 2.12-1.933 3.347.004 1.233.872 1.728 1.945 1.108"
                        opacity={1}
                        data-original="#3d3d3d"
                    />
                    <path
                        fill="#686868"
                        d="M45.537 31.137c0 1.235-.854 2.73-1.922 3.343-1.077.622-1.94.13-1.95-1.105 0-1.226.863-2.73 1.931-3.353 1.068-.612 1.94-.111 1.94 1.115z"
                        opacity={1}
                        data-original="#686868"
                    />
                    <path
                        fill="#bc2b3b"
                        d="m24.578 32.498-.014-4.984.253-.146c.077-.045.137-.004.137.078l.015 5.238c0 .043-.018.09-.045.134l-.375-.224a.253.253 0 0 0 .03-.096z"
                        opacity={1}
                        data-original="#bc2b3b"
                    />
                    <path
                        fill="#ef5a5a"
                        d="M24.442 32.727a.281.281 0 0 0 .107-.133l.375.224a.277.277 0 0 1-.091.094l-6.415 3.704c-.214.124-.369.022-.389-.187z"
                        opacity={1}
                        data-original="#ef5a5a"
                    />
                    <path
                        fill="#888888"
                        d="M44.418 31.722v.13s0 .009-.01.018v.066c0 .018-.009.036-.009.064v.01c-.009.027-.009.046-.018.064v.01c-.01.018-.01.046-.019.065v.009c-.009.028-.009.046-.018.065 0 0 0 .01-.01.01 0 .018-.009.045-.018.064 0 .01 0 .01-.01.01 0 .028-.009.046-.018.064 0 0 0 .01-.01.01a.62.62 0 0 0-.027.074c-.01.019-.028.037-.037.065v.01c-.028.037-.056.083-.084.13v.009c-.028.037-.056.083-.083.12l-.01.01c-.028.037-.065.074-.093.111 0 .01 0 .01-.009.01v.009l-.028.028c-.009 0-.009.009-.018.009 0 .009-.01.018-.019.028-.009 0-.009.009-.018.009l-.065.065c-.01 0-.01.01-.019.01-.01.008-.018.018-.028.018 0 .009-.009.009-.009.018-.01 0-.019.01-.028.02-.01 0-.01.008-.018.008-.01.01-.019.01-.028.019l-.01.01c-.018.008-.027.018-.046.027-.455.26-.817.046-.817-.464-.01-.52.362-1.152.808-1.412a.204.204 0 0 0 .046-.027c.01 0 .01-.01.019-.01s.018-.009.028-.009c0-.01.009-.01.009-.01.01 0 .018-.008.028-.008s.009-.01.018-.01.019-.009.028-.009h.01c.009-.01.018-.01.037-.01.018-.009.027-.009.037-.009.027-.01.055-.01.083-.01.065-.008.13 0 .195.029.028.01.056.028.084.046.01.01.018.019.037.028a.13.13 0 0 1 .028.037c.01.01.018.019.028.037h.009c.01.02.01.028.019.047h.009c0 .018.01.028.018.037v.01c.01.018.01.036.019.055s.01.028.01.046c0 .01.009.01.009.01 0 .018 0 .037.009.055v.065z"
                        opacity={1}
                        data-original="#888888"
                    />
                    <path
                        fill="#fee44b"
                        d="M3.9 35c.427.246.77.84.768 1.33-.002.498-.346.694-.773.448-.427-.247-.77-.84-.768-1.338.001-.49.346-.687.773-.44z"
                        opacity={1}
                        data-original="#fee44b"
                    />
                    <path
                        fill="#ffffff"
                        d="M5.18 35.59c.131.075.238.259.237.409l-.004 1.532c0 .15-.108.211-.238.136l-2.561-1.479a.522.522 0 0 1-.237-.409l.005-1.533c0-.15.107-.21.238-.135zm-1.285 1.188c.427.246.772.05.773-.448.001-.49-.341-1.084-.768-1.33s-.772-.05-.773.44c-.002.498.341 1.092.768 1.338"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#fee44b"
                        d="M14.027 40.865c.427.247.77.84.768 1.33-.001.498-.346.695-.773.448s-.776-.843-.774-1.34c.001-.49.352-.684.779-.438z"
                        opacity={1}
                        data-original="#fee44b"
                    />
                    <path
                        fill="#ffffff"
                        d="M15.308 41.455c.13.075.236.26.236.41l-.004 1.532c0 .15-.108.21-.238.135l-2.561-1.478a.522.522 0 0 1-.237-.41l.005-1.532c0-.15.107-.21.238-.136zm-1.286 1.188c.427.247.772.05.773-.447.001-.49-.341-1.084-.768-1.33s-.778-.054-.78.437c0 .497.348 1.094.775 1.34"
                        opacity={1}
                        data-original="#ffffff"
                    />
                </g>
            </svg>

        </>
    )
}

export default NdrInsightsIcon